import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'gradfast-ng';
  notification = '';
  nav = [
    {link: '/degrees/12134000', text: 'Computer Science'},
    {link: '/degrees/12130101', text: 'Computer Engineering'},
    {link: '/degrees/02130082', text: 'BIT'},
    {link: '/degrees/12133211', text: 'BSc (IT)'},
    {link: '/degrees/07130172', text: 'Informatics'},
    {link: '/degrees/12131005', text: 'Multimedia'}
  ];
}
